import { Alert, Button, Stack, TextField } from '@mui/material'
import { VpnKey } from '@mui/icons-material'

import { HttpError } from '@/api/http'

interface AccessCodeFormProps {
  code: string
  isPending: boolean
  error: HttpError | null
  onCodeChange: (code: string) => void
  onSubmit: () => void
}

const AccessCodeForm: React.FC<AccessCodeFormProps> = ({ code, isPending, error, onCodeChange, onSubmit }) => {
  return (
    <Stack
      spacing={2}
      width="100%"
      component="form"
      onSubmit={(event: React.FormEvent) => {
        event.preventDefault()
        onSubmit()
      }}
    >
      <TextField
        placeholder="Digite o código"
        value={code}
        size="medium"
        onChange={(event) => {
          onCodeChange(event.target.value)
        }}
        disabled={isPending}
        error={!!error}
        fullWidth
        slotProps={{
          input: {
            startAdornment: <VpnKey sx={{ color: 'action.active', mr: 1 }} />,
          },
          htmlInput: {
            style: { textTransform: 'uppercase', textAlign: 'center' },
            autoCapitalize: 'characters',
            autoCorrect: 'off',
          },
        }}
      />

      <Button
        type="submit"
        variant="contained"
        fullWidth
        loading={isPending}
        disabled={!code.trim()}
        sx={{ borderRadius: 20 }}
      >
        {isPending ? 'Validando código...' : 'Acessar carregador'}
      </Button>

      {error && <Alert severity="error">{error.message}</Alert>}
    </Stack>
  )
}

export default AccessCodeForm
